$(()=>{

    Pace.on('hide', ()=>{
        $('html').addClass('_ready');
        setTimeout(()=>{
            $(document).trigger('animate');
        }, 500);
    });
    setTimeout(()=>{
        $('html').addClass('_ready');
        setTimeout(()=>{
            $(document).trigger('animate');
        }, 500);
    }, 5000);

});